"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nano = require("./nano");
var _variables = require("./variables");
var tabControlsHeight = '31px';
var _default = exports["default"] = (0, _nano.sheet)({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    margin: '5px 0'
  },
  controls: {
    display: 'flex',
    height: tabControlsHeight,
    padding: '0 5px',
    margin: 0,
    whiteSpace: 'nowrap',
    listStyleType: 'none'
  },
  tabControl: {
    display: 'inline-flex',
    padding: '2px',
    margin: '0 1px',
    border: "1px solid ".concat(_variables.tabControlBorderColour),
    borderBottomColor: _variables.tabControlBorderBottomColour,
    zIndex: _variables.zIndexes.get('above-siblings')
  },
  tabControl_active: {
    marginBottom: '-1px'
  },
  panels: {
    position: 'relative',
    height: "calc(100% - ".concat(tabControlsHeight, ")"),
    minWidth: '400px',
    borderTop: '1px solid'
  },
  view: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    width: 'calc(100% - 10px)',
    height: '100%',
    padding: '5px',
    margin: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'all 1s ease-in-out',
    pointerEvents: 'none'
  },
  view_active: {
    position: 'relative',
    opacity: 1,
    visibility: 'visible',
    pointerEvents: 'auto',
    zIndex: _variables.zIndexes.get('above-siblings')
  }
});